var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"sms-badge",class:_vm.cls,attrs:{"title":_vm.title}},[_c('i',{class:_vm.meta.icon}),_c('span',{staticClass:"sms-badge-label"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }